import React, { useEffect, useState } from 'react'
import { TableCustom } from '../../components/Table'
import useAxiosInstance from '../../hooks/useAxios';
import { OBSERVABILITY_METRICS_TABLE_KEYS } from '../../helper';
import { Paginator } from '../../components/Paginator';
import { useDebounce } from "use-debounce";
import FormRender from '../../components/FormRender';
import Input from '../../components/input';

const ObservabilityMetrics = () => {
    const axiosInstance = useAxiosInstance()
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [intermidiatePageNumber, setIntermidiatePageNumber] = useState(1)
    const [pageSize, setPageSize] = useState(50)
    const [data, setData] = useState({})
    const [query, setQuery] = useState("")
    const [viewName] = useDebounce(query, 1000);
    const [startReportId, setStartReportId] = useState(null);
    const [endReportId, setEndReportId] = useState(null);
    const [sortBy, setSortBy] = useState('total');
    const [sortOrder, setSortOrder] = useState('desc');
    const [reportRangeRetrigger,setReportRangeRetrigger] = useState(0);

    useEffect(() => {
        setLoading(true);
        const controller = new AbortController();
        axiosInstance
            .post(
                `/workflow_manager/get_views_observability/`,
                {
                    "view_name": viewName,
                    "page": page,
                    "page_size": Number(pageSize),
                    "sort_by":sortBy,
                    "sort_order":sortOrder,
                    "report_id_start":startReportId,
                    "report_id_end":endReportId
                }
                , {
                    signal: controller.signal
                }
            )
            .then((res) => {
                setData(res.data);
                setLoading(false);
                setIntermidiatePageNumber(res.data.current_page)
            })
            .catch((err) => {
                console.log(err);
            });

        return () => {
            controller.abort();
        };
    }, [page, pageSize, viewName, sortBy, sortOrder, reportRangeRetrigger]);

    useEffect(() => {
        setPage(1)
        setIntermidiatePageNumber(1)
    }, [pageSize, viewName])

    return (
        <div className="p-2 overflow-x-auto bg-white mt-4 rounded-xl mr-3 border">
            <div className="flex justify-between mb-5">
                <span className="text-xl font-medium">Observability Metrics</span>
            </div>
            <Input
                value={query}
                onChange={e => setQuery(e.target.value)}
                placeholder='Search view name'
            />

            <div className='flex justify-between gap-3'>
                <div className='w-full'>
                    <div className="text-sm w-full font-semibold mb-2 mt-4">Sort by</div>
                    <select
                        value={sortBy}
                        onChange={(e) => {
                            setSortBy(e.target.value);
                        }}
                        className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
                        placeholder="Enter your password"
                    >
                        {["success", "failed", "no data", "not started", "success_percentage", "failed_percentage", "total"].map(item => {
                            return <option key={item} value={item} className='capitalize'>{item}</option>
                        })}
                    </select>
                </div>

                <div className='w-full'>
                    <div className="text-sm w-full font-semibold mb-2 mt-4">Sort Order</div>
                    <select
                        value={sortOrder}
                        onChange={(e) => {
                            setSortOrder(e.target.value);
                        }}
                        className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
                        placeholder="Enter your password"
                    >
                        {["choose", "desc", 'ascending'].map(item => {
                            return <option key={item} value={item} className='capitalize'>{item}</option>
                        })}
                    </select>
                </div>

            </div>
            <p className='text-sm font-semibold mt-3 mb-2'>Report Range</p>
            <div className='flex gap-x-3 justify-between'>
                <Input
                    value={startReportId}
                    type='number'
                    onChange={e => setStartReportId(e.target.value)}
                    placeholder='Enter Start Report ID(optional)'
                />
                <Input
                    value={endReportId}
                    onChange={e => setEndReportId(e.target.value)}
                    placeholder='Enter End Report ID(optional)'
                />
                <button onClick={()=>{
                    setReportRangeRetrigger(prev=>prev+1)
                }} className='text-sm rounded bg-black py-2 px-3 text-white'>Apply</button>
            </div>
            <div>
                <TableCustom
                    columns={OBSERVABILITY_METRICS_TABLE_KEYS}
                    data={data}
                    loading={loading}
                    className='min-h-[70vh] !max-h-[70vh]'
                />
                <Paginator
                    data={data}
                    loading={loading}
                    setPage={setPage}
                    setIntermidiatePageNumber={setIntermidiatePageNumber}
                    intermidiatePageNumber={intermidiatePageNumber}
                    setPageSize={setPageSize}
                    pageSize={pageSize}
                />
            </div>
        </div>
    )
}

export default ObservabilityMetrics